import i18next from "i18next";
import { CopyrightText, DeveloperLink, Separator } from "./style";

const FooterBottomComponent = () => {
  const { t } = i18next;

  return (
    <>
      <Separator />
      <CopyrightText>
        &copy; 2024 Aerix.dev. All rights reserved. ·{" "}
        <DeveloperLink href="https://aerix.dev" target="_blank" rel="noreferrer">{t("developed_by")}</DeveloperLink>
      </CopyrightText>
    </>
  );
};

export default FooterBottomComponent;
